// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	InstantSearchMobile.prototype.afterShowSearchBoxMobile = function(searchBoxId) {
		if (!searchBoxId) searchBoxId = this.searchBoxId;
		// Hide debut's search bar on mobile, and show our search bar instead
		if (jQ('.js-drawer-close').length > 0) {
			setTimeout(function() {
				jQ('.js-drawer-close').trigger('click');
			});
		}
	};

	SearchInput.prototype.customizeInstantSearch = function() {
		// Hide debut's search suggestion
		if (jQ('.predictive-search-wrapper').length > 0) {
			jQ('.predictive-search-wrapper').hide();
		}
	};

	function closeSuggestionMobile(searchBoxId, isCloseSearchBox) {
		/* console.log('closeSuggestionMobile'); */
		jQ(searchBoxId).autocomplete('close');
		jQ('.' + Class.searchSuggestion + '[data-search-box="' + searchBoxId + '"]').parent().hide();
		// Remove search box
		var isCloseSearchBox = typeof isCloseSearchBox !== 'undefined' ? isCloseSearchBox : false;
		if (isCloseSearchBox) jQ('.boost-pfs-search-suggestion-mobile-top-panel,.boost-pfs-search-suggestion-mobile-overlay').hide();
		// Update current term for all search boxes
		setValueAllSearchBoxes();
		// Add back tabindex=-1
		jQ('.boost-pfs-search-no-tabindex').attr('tabindex', -1);
		// Return scrolling of body
		if (jQ('body').hasClass(Class.searchSuggestionMobileOpen)) {
			jQ('body').removeClass(Class.searchSuggestionMobileOpen);
		}
		BoostPFS.afterCloseSuggestionMobile(searchBoxId, isCloseSearchBox);

		// Close search theme debut
		if (jQ('.js-drawer-close').length > 1) {
			jQ('.js-drawer-close').trigger('click');
		}
	}

	var instantSearchTemplate = InstantSearchResultBlock.prototype.getTemplate;

	InstantSearchResultBlock.prototype.getTemplate = function(tempType) {
		if (['products', 'collections'].indexOf(tempType) === -1) return instantSearchTemplate.call(this, tempType);

		return '<li class="{{class.searchSuggestionGroup}} ' + tempType + '" data-group="{{type}}" aria-label="{{label}}">' +
			'<ul class="default">' +
			'<li class="{{class.searchSuggestionHeader}}-{{type}} {{class.searchSuggestionHeader}}" aria-label="{{label}}">{{label}}</li>' +
			'{{resultItems}}' +
			'</ul>' +
			// '<ul class="custom">' +
			// '<li class="{{class.searchSuggestionHeader}}-{{type}} {{class.searchSuggestionHeader}}" aria-label="{{label}}">' +
			// (tempType === 'products' ? 'PRODUCTS' : '') +
			// (tempType === 'collections' ? 'COLECCIONES' : '') +
			// '</li>' +
			// '{{resultItems}}' +
			// '</ul>' +
			'</li>';
	}

	InstantSearchResultBlock.prototype.compileTemplate = function() {
		if ((this.status != 'active' || !this.isShow) && !this._isShowDYM()) {
			return '';
		}
		var label = this.isAllEmpty ? this.notFoundLabel : this.label;

		return this.getTemplate(this.type)
			.replace(/{{type}}/g, this.type)
			.replace(/{{label}}/g, label)
			.replace(/{{class.searchSuggestionHeader}}/g, Class.searchSuggestionHeader)
			.replace(/{{class.searchSuggestionGroup}}/g, Class.searchSuggestionGroup)
			.replace(/{{resultItems}}/g, '');
	}

	/**
	 * Render the instant search result block
	 * @returns {Object} jQuery object
	 */
	InstantSearchResultBlock.prototype.render = function() {
		this.$element = jQ(this.compileTemplate());
		var self = this;
		// Add Did you mean block in product block
		/*
		if (this.type && this.type === InstantSearchEnum.ResultType.PRODUCTS) {
			this.blockDym.render();
			if (this.blockDym.$element) {
				this.$element = jQ(this.compileTemplate());
				this.$element.find('> ul').append(this.blockDym.$element);
			}
		}
        */

		if (['products', 'collections'].indexOf(this.type) !== -1) {
			this.children.forEach(function(child) {
				if (child.$element) {
					if (child.data.tags && child.data.tags.includes('sinprecio') && user.logged == false) {
						jQ(child.$element).find('.boost-pfs-search-suggestion-product-price').html('<span class="boost-pfs-search-suggestion-product-regular-price professionals-only-price"><span class="hidePrice">* Exclusivo para profesionales</span></span>');
						self.$element.find('> ul.default').append(child.$element);
					} else {
						self.$element.find('> ul.default').append(child.$element);
					}
				}
			})
			if (self.$element.find('ul.default').children().length <= 1) {
				self.$element.find('ul.default').remove()
			}
			if (self.$element.find('ul.default').children().length <= 1) {
				self.$element.find('ul.default').remove()
			}
		} else {
			this.children.forEach(function(child) {
				if (child.$element) {
					self.$element.find('> ul').append(child.$element);
				}
			});
		}
	}

	InstantSearchApi.beforeCall = function(eventType, eventInfo) {
		if (Shopify && Globals) {
			Globals.instantSearchQueryParams.currency = Shopify.currency.active;
			Globals.instantSearchQueryParams.currency_rate = Shopify.currency.rate;
			Globals.instantSearchQueryParams.country = Shopify.country;
			Globals.instantSearchQueryParams.return_all_currency_fields = false;
		}
	}
})();